import React from 'react';
import './FactionInsectoidsDescription.css';

const FactionInsectoidsDescription = () => {
  const supply = <img
    className="faction-description-icon faction-description-icon-margin-right-left" src="/img/icons/supply.png"
    alt="снабжение" title="Снабжение"
  />;
  const size = <img
    className="faction-description-icon faction-description-icon-margin-right-left" src="/img/icons/unit size.png"
    alt="Размер отряда" title="Размер отряда"
  />;
  const hex = <img
    className="faction-description-icon faction-description-icon-margin-right-left"
    src="/img/icons/cell.png"
    alt="Ячейка"
    title="Ячейка"
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  return (
    <>
      <div className="policy-description_line">
        В
        <span className={'text-supply policy-description-icon-margin-left-end'}>
          фазе Снабжения
        </span>
        {unit} всегда получает
      </div>
      <div className="policy-description_line">
        базовое {supply}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top-paragraph-large">
        {size} {unit} не увеличивается на пустой {hex}.
      </div>
    </>
  );
};

export default FactionInsectoidsDescription;
